export const COUNTRY_LIST_ID = 'heatmap-country-list';
export const COUNTRY_LIST_SUB_HEADING = 'heatmap-country-list-subheading';
